module.exports = __webpack_public_path__ + "img/joehillssays-f92e37ee-f43d-4e73-489d-08d95b7e528f.png";